"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDotProperty = exports.sliceDuration = exports.getTimeSymbolTitle = exports.formatDuration = exports.formatTime = exports.formatHumanDateTime = exports.formatHumanDate = exports.caseInsensitiveCompare = exports.formatAddress = void 0;
const moment_1 = __importDefault(require("moment"));
const formatAddress = (address = "") => address.slice(0, 4) + "..." + address.slice(address.length - 4, address.length);
exports.formatAddress = formatAddress;
const caseInsensitiveCompare = (left = "", right = "") => (left && right && left.toLocaleLowerCase() === right.toLocaleLowerCase()) || left === right;
exports.caseInsensitiveCompare = caseInsensitiveCompare;
const formatHumanDate = (date) => (0, moment_1.default)(date).format("DD MMM, yyyy");
exports.formatHumanDate = formatHumanDate;
const formatHumanDateTime = (date) => (0, moment_1.default)(date).format("MMMM DD, yyyy [at] hh:mm:ss a");
exports.formatHumanDateTime = formatHumanDateTime;
const formatTime = (value) => `00${value}`.slice(-2);
exports.formatTime = formatTime;
const formatDuration = (durationInSec) => {
    return (0, exports.sliceDuration)(durationInSec).filter(Boolean).join(" : ");
};
exports.formatDuration = formatDuration;
const TIME_SYMBOL_DICTIONARY = {
    Y: "year",
    M: "month",
    D: "day",
    h: "hour",
    m: "min",
    s: "sec",
};
const getTimeSymbolTitle = (value, symbol) => {
    return `${TIME_SYMBOL_DICTIONARY[symbol]}${value > 1 ? "s" : ""}`;
};
exports.getTimeSymbolTitle = getTimeSymbolTitle;
const sliceDuration = (durationInSec, [yearLabel = "Y", monthLabel = "M", dayLabel = "D", hourLabel = "h", minLabel = "m", secLabel = "s"] = []) => {
    const duration = moment_1.default.duration(durationInSec, "seconds");
    const yearsLeft = duration.years();
    const monthLeft = duration.months();
    const daysLeft = duration.days();
    const hoursLeft = duration.hours();
    const minutesLeft = duration.minutes();
    const secondsLeft = duration.seconds();
    return [
        yearsLeft ? yearsLeft + yearLabel : "",
        monthLeft ? monthLeft + monthLabel : "",
        daysLeft ? daysLeft + dayLabel : "",
        hoursLeft ? (0, exports.formatTime)(hoursLeft) + hourLabel : "",
        minutesLeft ? (0, exports.formatTime)(minutesLeft) + minLabel : "",
        secondsLeft ? (0, exports.formatTime)(secondsLeft) + secLabel : "",
    ].filter(Boolean);
};
exports.sliceDuration = sliceDuration;
const setDotProperty = (obj, propPath, value) => {
    const [rootPathSection, ...other] = propPath.split(".");
    const pathToValue = other.join(".");
    if (!obj[rootPathSection]) {
        obj[rootPathSection] = {};
    }
    if (pathToValue) {
        return (0, exports.setDotProperty)(obj[rootPathSection], pathToValue, value);
    }
    else {
        obj[rootPathSection] = value;
        return obj;
    }
};
exports.setDotProperty = setDotProperty;
